<nav id="anchor-container" class="navigation">
  <ul class="navigation-list">
    <li *ngFor="let anchor of anchors;" class="navigation-item">
      <a [routerLink]="'.'"
         [fragment]="anchor?.anchor | translate"
         [class.active]="(anchor?.anchor | translate) === (fragment | async)"
         (click)="scrollTo(anchor?.anchor)"
         class="link"
      >
        {{anchor?.title | translate}}
      </a>
    </li>
  </ul>
</nav>
